<template>
  <div>
    <div class="row">
      <!-- Date Buttons Filter Start -->
      <div class="col-md-7">
        <div class="row">
          <div class="col-md" v-for="(button, index) in options.dateButtons">
            <button class="btn btn--ahmoil-v3" :class="{ selected: selected.dateButtonsIndex == index }"
              @click="selectDateButton(index)">
              {{ button.title }}
            </button>
          </div>
        </div>
      </div>
      <!-- Date Buttons Filter End -->

      <!-- Flat Pickr and Variant Select Start -->
      <div class="col-md-5">
        <div class="row">
          <div class="col-md-7 filter-date pl-2 w-full bg-white d-flex align-items-center"
            :class="{ 'col-md-7': !hideFilterVariant, 'col-md-12': hideFilterVariant }">
            <a class="input-button px-2" data-toggle>
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.9659 1.79591H13.17V0.598648C13.17 0.268019 12.902 0 12.5714 0C12.2407 0 11.9727 0.268019 11.9727 0.598648V1.79591H4.78908V0.598648C4.78908 0.268019 4.52106 0 4.19047 0C3.85987 0 3.59182 0.268019 3.59182 0.598648V1.79591H1.79591C0.804056 1.79591 0 2.59997 0 3.59182V14.9659C0 15.9578 0.804056 16.7618 1.79591 16.7618H14.9659C15.9578 16.7618 16.7618 15.9578 16.7618 14.9659V3.59182C16.7618 2.59997 15.9578 1.79591 14.9659 1.79591ZM15.5645 14.9659C15.5645 15.2966 15.2965 15.5646 14.9659 15.5646H1.79591C1.46528 15.5646 1.19726 15.2966 1.19726 14.9659V7.18364H15.5645V14.9659ZM15.5645 5.98638H1.19726V3.59182C1.19726 3.26119 1.46528 2.99317 1.79591 2.99317H3.59182V4.19043C3.59182 4.52106 3.85984 4.78908 4.19047 4.78908C4.5211 4.78908 4.78912 4.52106 4.78912 4.19043V2.99317H11.9728V4.19043C11.9728 4.52106 12.2408 4.78908 12.5714 4.78908C12.902 4.78908 13.1701 4.52106 13.1701 4.19043V2.99317H14.966C15.2966 2.99317 15.5646 3.26119 15.5646 3.59182L15.5645 5.98638Z"
                  fill="#2D2D2D" />
                <path
                  d="M4.78809 8.38086H3.59084C3.26021 8.38086 2.99219 8.64886 2.99219 8.97949C2.99219 9.31012 3.26021 9.57816 3.59084 9.57816H4.78809C5.11873 9.57816 5.38674 9.31012 5.38674 8.97949C5.38674 8.64886 5.11873 8.38086 4.78809 8.38086Z"
                  fill="#2D2D2D" />
                <path
                  d="M8.97951 8.38086H7.78224C7.45161 8.38086 7.18359 8.64886 7.18359 8.97949C7.18359 9.31012 7.45161 9.57816 7.78224 9.57816H8.97951C9.31013 9.57816 9.57814 9.31012 9.57814 8.97949C9.57814 8.64886 9.31013 8.38086 8.97951 8.38086Z"
                  fill="#2D2D2D" />
                <path
                  d="M13.1709 8.38086H11.9736C11.643 8.38086 11.375 8.64886 11.375 8.97949C11.375 9.31012 11.643 9.57816 11.9736 9.57816H13.1709C13.5015 9.57816 13.7696 9.31012 13.7696 8.97949C13.7695 8.64886 13.5015 8.38086 13.1709 8.38086Z"
                  fill="#2D2D2D" />
                <path
                  d="M4.78809 10.7754H3.59084C3.26021 10.7754 2.99219 11.0434 2.99219 11.3741C2.99219 11.7047 3.26021 11.9727 3.59084 11.9727H4.78809C5.11873 11.9727 5.38674 11.7047 5.38674 11.3741C5.38674 11.0434 5.11873 10.7754 4.78809 10.7754Z"
                  fill="#2D2D2D" />
                <path
                  d="M8.97951 10.7754H7.78224C7.45161 10.7754 7.18359 11.0434 7.18359 11.3741C7.18359 11.7047 7.45161 11.9727 7.78224 11.9727H8.97951C9.31013 11.9727 9.57814 11.7047 9.57814 11.3741C9.57814 11.0434 9.31013 10.7754 8.97951 10.7754Z"
                  fill="#2D2D2D" />
                <path
                  d="M13.1709 10.7754H11.9736C11.643 10.7754 11.375 11.0434 11.375 11.3741C11.375 11.7047 11.643 11.9727 11.9736 11.9727H13.1709C13.5015 11.9727 13.7696 11.7047 13.7696 11.3741C13.7695 11.0434 13.5015 10.7754 13.1709 10.7754Z"
                  fill="#2D2D2D" />
                <path
                  d="M4.78809 13.1699H3.59084C3.26021 13.1699 2.99219 13.438 2.99219 13.7686C2.99219 14.0992 3.26021 14.3672 3.59084 14.3672H4.78809C5.11873 14.3672 5.38674 14.0992 5.38674 13.7686C5.38674 13.4379 5.11873 13.1699 4.78809 13.1699Z"
                  fill="#2D2D2D" />
                <path
                  d="M8.97951 13.1699H7.78224C7.45161 13.1699 7.18359 13.438 7.18359 13.7686C7.18359 14.0992 7.45161 14.3672 7.78224 14.3672H8.97951C9.31013 14.3672 9.57814 14.0992 9.57814 13.7686C9.57814 13.438 9.31013 13.1699 8.97951 13.1699Z"
                  fill="#2D2D2D" />
                <path
                  d="M13.1709 13.1699H11.9736C11.643 13.1699 11.375 13.438 11.375 13.7686C11.375 14.0992 11.643 14.3672 11.9736 14.3672H13.1709C13.5015 14.3672 13.7696 14.0992 13.7696 13.7686C13.7696 13.438 13.5015 13.1699 13.1709 13.1699Z"
                  fill="#2D2D2D" />
              </svg>
            </a>
            <flat-pickr :config="rangePickr" placeholder="Select Date" v-model="selected.date"></flat-pickr>
          </div>
          <div class="col-md-5" v-if="!hideFilterVariant">
            <MultiSelect v-model="filter.variant" :options="options.variant" :deselect-label="''" :select-label="''"
              placeholder="All Variants" class="elegant-multiselect variant-select" />
          </div>
        </div>
      </div>
      <!-- Flat Pickr and Variant Select End -->
    </div>
  </div>
</template>

<script>
import moment from "moment";
import debounce from "debounce";

moment.updateLocale("en", {
  week: { dow: 1 },
});

export default {
  data() {
    let startDate = moment().startOf("month").format("YYYY-MM-DD");
    let currentDate = moment().format("YYYY-MM-DD");

    const rangeSeparator = " s/d ";

    return {
      rangeSeparator,
      rangePickr: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d-m-y",
        altInputClass: "form-control input elegant-flatpickr",
        locale: {
          rangeSeparator,
        },
      },

      options: {
        dateButtons: [
          {
            title: "Today",
            start: `${moment().format("YYYY-MM-DD")}`,
            end: `${moment().format("YYYY-MM-DD")}`,
            filter: "DAILY",
          },
          {
            title: "This Week",
            start: `${moment().startOf("week").format("YYYY-MM-DD")}`,
            end: `${moment().format("YYYY-MM-DD")}`,
            filter: "WEEKLY",
          },
          {
            title: "This Month",
            start: `${moment().startOf("month").format("YYYY-MM-DD")}`,
            end: `${moment().format("YYYY-MM-DD")}`,
            filter: "MONTHLY",
          },
          {
            title: "This Year",
            start: `${moment().startOf("year").format("YYYY-MM-DD")}`,
            end: `${moment().format("YYYY-MM-DD")}`,
            filter: "YEARLY",
          },
        ],
        variant: this.$store.getters.getVariant,
      },
      selected: {
        dateButtonsIndex: 2,
        date: `${startDate}${rangeSeparator}${currentDate}`,
      },
      filter: {
        start: startDate,
        end: currentDate,
        variant: null,
        filter: "MONTHLY",
      },
      isMounted: false, // Track if component has finished mounting
      explicitButtonClick: null, // Track which button was explicitly clicked
    };
  },
  props: ["getFilterOnStart", "hideFilterVariant"],
  created() {
    console.log("[customFilter] CREATED");
  },
  mounted() {
    console.log("[customFilter] MOUNTED - getFilterOnStart:", this.getFilterOnStart);
    this.isMounted = true;
    if (this.getFilterOnStart) {
      console.log("[customFilter] Calling debouncelessEmitFilter");
      this.debouncelessEmitFilter();
    }
  },
  watch: {
    "selected.date"() {
      const rawDate = this.selected.date || "";
      const separator = this.getRangeSeparator();
      let split = typeof rawDate === "string" && separator ? rawDate.split(separator) : [];

      if (split.length <= 1 && typeof rawDate === "string" && rawDate.includes(" to ")) {
        split = rawDate.split(" to ");
      }

      const start = split[0] ? split[0].trim() : "";
      const end = split.length > 1 && split[1] ? split[1].trim() : start;

      this.filter.start = start;
      this.filter.end = end;

      //Check End
      if (this.filter.end != moment().format("YYYY-MM-DD")) {
        this.selected.dateButtonsIndex = -1;
        this.explicitButtonClick = null; // Clear explicit click when custom date is set
        //Check Start
      } else if (this.options.dateButtons.map((x) => x.start).indexOf(this.filter.start) == -1) {
        this.selected.dateButtonsIndex = -1;
        this.explicitButtonClick = null; // Clear explicit click when custom date is set
        //Found Match - but need special handling for first day of week
      } else {
        // Check if today is the first day of the week
        const isFirstDayOfWeek = moment().day() === 1; // 1 = Monday
        const thisWeekButton = this.options.dateButtons[1]; // Index 1 is "This Week"
        
        // Special case: if today is the first day of the week
        if (isFirstDayOfWeek) {
          // If user explicitly clicked "This Week" button, keep it selected
          // even though the date range matches "Today"
          if (this.explicitButtonClick === 1 && 
              this.filter.start === thisWeekButton.start && 
              this.filter.end === thisWeekButton.end) {
            // User clicked "This Week", keep it selected
            this.selected.dateButtonsIndex = 1; // "This Week"
          } else {
            // Use the normal matching logic
            const matchedIndex = this.options.dateButtons
              .map((x) => x.start)
              .indexOf(this.filter.start);
            this.selected.dateButtonsIndex = matchedIndex;
            // Clear explicit click after processing
            this.explicitButtonClick = null;
          }
        } else {
          // Normal matching logic for other days
          this.selected.dateButtonsIndex = this.options.dateButtons
            .map((x) => x.start)
            .indexOf(this.filter.start);
          this.explicitButtonClick = null; // Clear explicit click
        }
      }
    },
    "selected.dateButtonsIndex"() {
      this.filter.filter =
        this.selected.dateButtonsIndex != -1
          ? this.options.dateButtons[this.selected.dateButtonsIndex].filter
          : "CUSTOM";
    },
    filter: {
      deep: true,
      handler(newVal, oldVal) {
        // Only emit if component has finished mounting
        // This prevents duplicate emissions during initialization
        if (this.isMounted) {
          this.emitFilter();
        }
      },
    },
  },
  methods: {
    selectDateButton(i) {
      // Store which button was explicitly clicked
      this.explicitButtonClick = i;
      const separator = this.getRangeSeparator();
      this.selected.date = `${this.options.dateButtons[i].start}${separator}${this.options.dateButtons[i].end}`;
      this.selected.dateButtonsIndex = i;
    },
    debouncelessEmitFilter() {
      console.log("[customFilter] debouncelessEmitFilter - emitting filterChange NOW");
      this.$emit("filterChange", this.filter);
    },
    emitFilter: debounce(function (e) {
      console.log("[customFilter] emitFilter (debounced) - emitting filterChange NOW");
      this.$emit("filterChange", this.filter);
    }, 1500),
    getRangeSeparator() {
      if (this.rangeSeparator) {
        return this.rangeSeparator;
      }
      if (this.rangePickr && this.rangePickr.locale && this.rangePickr.locale.rangeSeparator) {
        return this.rangePickr.locale.rangeSeparator;
      }
      return " to ";
    },
  },
};
</script>

<style scoped>
.btn--ahmoil-v3 {
  background-color: white;
  color: #b5b5b5;
  width: 100%;
  text-align: left;
  height: 36px;
}

.btn--ahmoil-v3.selected {
  background-color: #d5e8ff;
  color: #134f97;
}

/* Make variant select placeholder bold */
::v-deep(.variant-select .multiselect__placeholder) {
  font-weight: 600 !important;
}
</style>